<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="blood_apply-list"
            :url="url"
            :columns="columnList"
            :buttons="[]"
            dialogWidth="80%"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @loadingPullBloodView="loadingPullBloodView"
            @printBloodPull="printBloodPull"
        >
            <slot slot="filter">
                <el-col :md="9" :lg="7" :xl="5">
                    <item-input type="daterange" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
                <el-col :md="5" :lg="4" :xl="3">
                    <item-input type="select" v-model="dic_operating_ward_id" :options="operation_ward_auth" :clearable="true" placeholder="请选择区域"></item-input>
                </el-col>
            </slot>
        </crud-facecade>
        <el-dialog title="领血" width="90%" :close-on-click-modal="false" :visible.sync="pullBlood.dialogFormVisible">
            <h3 class="margin5 align-left">患者基本信息</h3>
            <cus-form :data="pullBlood.data" :columns="pullBloodColumns"></cus-form>
            <el-row>
                <el-col :span="8" class="padding5">
                    <h3 class="margin20 margin-none-h align-left">输血申请详情</h3>
                    <item-input type="table2" v-model="pullBlood.data.application_list" class="table-h340" :options="applyBloodColumns"></item-input>
                </el-col>
                <el-col :span="16" class="padding5">
                    <el-row class="align-left">
                        <el-col :span="4"><h3 class="margin20 margin-none-h align-left">领血详情</h3></el-col>
                        <el-col :span="6" class="padding10 padding-none-h margin5 align-left">
                            <item-input type="scan" v-model="pullBlood.code" style="widht: 180px" placeholder="请扫码/输入血袋号" :autofocus="true"></item-input>
                        </el-col>
                        <el-col :span="6" class="padding10 padding-none-h margin5 align-left">
                            <el-button type="primary" size="mini" @click="addUsedBlood()"><i class="el-icon-plus"></i>添加</el-button>
                        </el-col>
                    </el-row>
                    <item-input type="table2" v-model="pullBlood.data.blood_pull_detail" class="table-h340" :options="usedBloodColumns" @extrabutton-click="ExtraButtonClick"></item-input>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BloodPull`,
    props: {},
    data() {
        return {
            title: `领血`,
            url: {
                area: `bloodpull`,
                get: () => {
                    return this.loadBloodApply()
                }
            },
            bloodDic: [],
            o_dic_operating_ward_id: undefined,
            issetoperatingward: false,
            rdate: [
                this.$moment()
                    .add(-2, `days`)
                    .format(`YYYY/MM/DD`),
                this.$moment()
                    .add(1, `days`)
                    .format(`YYYY/MM/DD HH:mm:ss`)
            ],
            pullBlood: {
                dialogFormVisible: false,
                code: ``,
                data: {}
            }
        }
    },
    mounted() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.loadBloodDic()
    },
    computed: {
        ...mapGetters([`sys_enums`, `operation_ward_auth`, `currentUser`, `active_ward`]),
        dic_operating_ward_id: {
            get: function() {
                if (!this.issetoperatingward && this.active_ward && _.startsWith(this.active_ward.value, `ow_`)) {
                    this.o_dic_operating_ward_id = this.active_ward.origion
                }
                return this.o_dic_operating_ward_id
            },
            set: function(v) {
                this.o_dic_operating_ward_id = v
                this.issetoperatingward = true
            }
        },
        columnList() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `no`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `patient_name`,
                    label: `姓名`,
                    // width:"140",
                    searchable: true,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `blood_type`,
                    label: `血型`,
                    // width:"140",
                    searchable: true,
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_operating_ward_id`,
                    label: `手术区`,
                    options: this.operation_ward_auth,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `申请医生`,
                    // width:"140",
                    searchable: true,
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `apply_date`,
                    label: `申请时间`,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `blood_status`,
                    label: `状态`,
                    searchable: true,
                    width: `140`,
                    isListable: true
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    fixed: `right`,
                    width: `120`,
                    isListable: true,
                    readonly: false,
                    options: [
                        {
                            class: `is-plain`,
                            label: `领血`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadingPullBloodView`,
                            permission: `default`
                        },
                        {
                            class: `is-plain`,
                            label: `打印`,
                            icon: ``,
                            type: ``,
                            emit: `printBloodPull`,
                            permission: `default`
                        }
                    ]
                }
            ]
        },
        pullBloodColumns() {
            return [
                {
                    type: `p`,
                    prop: `patient_name`,
                    label: `姓名:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `sex`,
                    label: `性别:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `age`,
                    label: `年龄:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `visit_no`,
                    label: `${this.T(`blood_pull.visit_no`)}:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `dic_opearting_ward`,
                    label: `手术区:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `dic_operating_room`,
                    label: `手术间:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `blood_type`,
                    label: `血型:`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `use_blood_type`,
                    label: `输血类型`,
                    readonly: true,
                    colspan: 4
                },
                {
                    type: `p`,
                    prop: `execute_date`,
                    label: `预定输血日期:`,
                    // default:this.$moment(execute_date).format("YYYY/MM/DD HH:mm:ss"),
                    readonly: true,
                    colspan: 5
                },
                {
                    type: `p`,
                    prop: `modifier`,
                    label: { content: `申请医师`, width: `80px` },
                    readonly: true,
                    colspan: 5
                }
            ]
        },
        applyBloodColumns() {
            return [
                {
                    type: `select`,
                    prop: `name`,
                    label: `血液分类`,
                    width: `260`,
                    isListable: true
                },
                {
                    type: `number`,
                    prop: `quantity`,
                    label: `输血量`,
                    width: `70`,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `unit`,
                    label: `单位`,
                    width: `50`,
                    isListable: true
                }
            ]
        },
        usedBloodColumns() {
            return [
                {
                    type: `string`,
                    prop: `id`,
                    label: `no`,
                    isKey: true
                },
                {
                    type: `string`,
                    prop: `code`,
                    label: `血袋号`,
                    width: `120`,
                    readonly: (that, { row }) => {
                        return row.section_check_time
                    },
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `dic_blood_id`,
                    label: `血液分类`,
                    // width:'200',
                    isListable: true,
                    readonly: (that, { row }) => {
                        return row.section_check_time
                    },
                    options: _.map(this.bloodDic, d => {
                        return {
                            value: d.id,
                            code: d.code,
                            label: d.name,
                            jianpin: d.abbr
                        }
                    }),
                    change: (that, { row }) => {
                        let r = _.find(this.bloodDic, { id: row.dic_blood_id })
                        row.unit = r && r.unit
                    }
                },
                {
                    type: `select`,
                    prop: `enum_blood_type`,
                    label: `血型`,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.section_check_time
                    },
                    options: this.sys_enums.Enum_BloodType || [],
                    isListable: true
                },
                {
                    type: `select`,
                    prop: `enum_blood_type_rh`,
                    label: `RH血型`,
                    width: `100`,
                    readonly: (that, { row }) => {
                        return row.section_check_time
                    },
                    options: this.sys_enums.Enum_RhBloodType || [],
                    isListable: true
                },
                {
                    type: `float`,
                    prop: `quantity`,
                    label: `血量`,
                    width: `140`,
                    readonly: (that, { row }) => {
                        return row.section_check_time
                    },
                    // default:0,
                    isListable: true
                },
                {
                    type: `string`,
                    prop: `unit`,
                    label: `单位`,
                    width: `80`,
                    readonly: (that, { row }) => {
                        return row.section_check_time
                    },
                    isListable: true
                },
                {
                    type: `datetime`,
                    prop: `valid_date`,
                    label: `失效时间`,
                    default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    colspan: 8
                },
                {
                    type: `string`,
                    prop: `modifier`,
                    label: `核对人`,
                    default: this.currentUser && this.currentUser.username,
                    colspan: 8
                },
                {
                    type: `datetime`,
                    prop: `check_time`,
                    label: `核对时间`,
                    default: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    colspan: 8
                },
                {
                    type: `buttongroup`,
                    prop: `oper`,
                    label: `操作`,
                    width: `160`,
                    isListable: true,
                    readonly: false,
                    options: (that, { row }) => {
                        let r = []
                        if (!row.section_check_time) {
                            r.push({
                                class: `is-plain`,
                                label: `核对`,
                                icon: ``,
                                type: `primary`,
                                emit: `check`,
                                permission: `default`
                            })
                            if (!row.is_from_interface && row.enum_using_blood_status == 0) {
                                r.push({
                                    class: `is-plain`,
                                    label: `删除`,
                                    icon: ``,
                                    type: `danger`,
                                    emit: `remove`,
                                    permission: `default`
                                })
                            }
                        }
                        return r
                    }
                }
            ]
        }
    },
    methods: {
        loadBloodDic() {
            let req = this.myaxios.get(`/api/AcisSystem/BloodDic/Get`)
            req.then(data => {
                this.bloodDic = data
            }).catch(e => {
                console.log(e)
            })
        },
        loadBloodApply() {
            let that = this
            return new Promise((resolve, reject) => {
                let req = this.myaxios.get(`/api/Nursing/Blood/GetByDate`, { from: that.rdate[0], to: that.rdate[1] })
                req.then(data => {
                    let r = _.filter(data, d => {
                        return d.enum_blood_status > 0
                    })
                    if (that.dic_operating_ward_id) {
                        r = _.filter(r, { dic_operating_ward_id: that.dic_operating_ward_id })
                    }
                    resolve(r)
                }).catch(e => reject(e))
            })
        },
        loadUseDetail(row) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/Nursing/Blood/GetUseDetail?surgeryId=${row.biz_surgery_info_id}`)
                req.then(data => {
                    let r = _.filter(data, { biz_blood_header_id: row.id })
                    resolve(r)
                }).catch(e => {
                    resolve([])
                })
            })
        },
        loadingPullBloodView({ row }) {
            let req1 = this.myaxios.get(`/api/Nursing/Blood/Get/${row.id}`)
            let req2 = this.myaxios.get(`/api/Preoperative/Apply/Get/${row.biz_surgery_info_id}`)
            let req3 = this.loadUseDetail(row)
            this.myaxios.all(req1, req2, req3).then(([applay, surgery, used]) => {
                let r = Object.assign(
                    {
                        patient_name: surgery.visit_info.name,
                        age: surgery.visit_info.age,
                        sex: surgery.visit_info.sex,
                        visit_no: surgery.visit_info.visit_no,
                        dic_operating_room: surgery.dic_operating_room,
                        dic_opearting_ward: surgery.dic_opearting_ward,
                        diseases: surgery.plan_diseases && _.map(surgery.plan_diseases, d => d.label).toString(),
                        blood_pull_detail: used.map(d => {
                            d.unit = d.blood.unit
                            return d
                        })
                    },
                    applay,
                    { blood_type: `${applay.blood_type}(${applay.blood_type_rh})`, execute_date: (applay.execute_date && this.$moment(applay.execute_date).format(`YYYY/MM/DD`)) || `--` }
                )
                this.pullBlood.data = r
                this.pullBlood.dialogFormVisible = true
            })
        },
        printBloodPull({ row }) {
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: {
                    docid: this.$root.DOCUMENT.SX010,
                    id1: row.biz_surgery_info_id,
                    objId: row.id
                }
            })
        },
        saveBlood(row) {},
        addUsedBlood() {
            this.pullBlood.data.blood_pull_detail.push({
                code: this.pullBlood.code,
                enum_using_blood_status: 0,
                is_from_interface: false,
                check_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                valid_date: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                enum_blood_type: this.pullBlood.data.enum_blood_type,
                enum_blood_type_rh: this.pullBlood.data.enum_blood_type_rh
            })
            this.pullBlood.code = ``
        },
        ExtraButtonClick(row) {
            this[row.emit] && this[row.emit](row)
        },
        remove({ row, index }) {
            if (!row.section_check_time) {
                this.pullBlood.data.blood_pull_detail.splice(index, 1)
            }
        },
        check({ row, index }) {
            if (!row.dic_blood_id) {
                this.$message.warning(`血液种类必填`)
                return
            }
            if (!row.quantity || row.quantity <= 0) {
                this.$message.warning(`血量不能为0`)
                return
            }
            // row.section_check_time = this.$moment().format('YYYY/MM/DD HH:mm:ss')//锁定改行，避免误操作删除,删除时校验该字段
            let req
            if (!row.is_from_interface) {
                req = this.myaxios.post(`/api/Nursing/Blood/PostUseBlood`, {
                    id: row.id,
                    biz_blood_header_id: this.pullBlood.data.id, // 血液申请id
                    biz_surgery_info_id: this.pullBlood.data.biz_surgery_info_id,
                    enum_using_blood_status: 0,
                    dic_blood_id: row.dic_blood_id,
                    quantity: row.quantity,
                    code: row.code,
                    enum_blood_type: row.enum_blood_type,
                    enum_blood_type_rh: row.enum_blood_type_rh,
                    valid_date: row.valid_date,
                    // "check_time":row.check_time,
                    is_from_interface: false,
                    section_check_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    section_check_worker: this.currentUser.username,
                    blood: {
                        id: row.dic_blood_id
                    }
                })
            } else {
                req = this.myaxios.put(`/api/Nursing/Blood/PutUseBlood`, {
                    id: row.id,
                    section_check_time: this.$moment().format(`YYYY/MM/DD HH:mm:ss`),
                    section_check_worker: this.currentUser.username
                })
            }

            req.then(data => {
                this.$set(row, `section_check_time`, this.$moment().format(`YYYY/MM/DD HH:mm:ss`))
                // this.loadUseDetail({
                //   "id":this.pullBlood.data.id,//血液申请id
                //   "biz_surgery_info_id":this.pullBlood.data.biz_surgery_info_id
                // }).then(data=>{
                //   this.pullBlood.data.blood_pull_detail = data.map(d=>{
                //     d.unit=d.blood.unit
                //     return d
                //   })
                // })
                // console.log(index)
            }).catch(e => {
                console.log(e)
            })
        }
    },
    watch: {
        dic_operating_ward_id: function() {
            this.$refs[`blood_apply-list`].ReloadListData()
        },
        rdate: function() {
            this.$refs[`blood_apply-list`].ReloadListData()
        }
    }
}
</script>
<style  lang="less">
.blood_type p {
    color: red !important;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/Blood/Pull.vue